/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SubjectMatterExpertContactDetails { 
    /**
     * The full name of the Subject Matter Expert
     */
    fullName?: string;
    /**
     * The job title of the Subject Matter Expert
     */
    jobTitle?: string;
    /**
     * The e-mail address of the Subject Matter Expert
     */
    emailAddress?: string;
    /**
     * The telephone number of the Subject Matter Expert
     */
    telephoneNumber?: string;
}
